import { render, staticRenderFns } from "./ChequePayments.vue?vue&type=template&id=30478688"
import script from "./ChequePayments.vue?vue&type=script&lang=js"
export * from "./ChequePayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports